var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobileHome"},[_c('mobile-header',_vm._l((_vm.proList),function(item,i){return _c('mobile-image',{key:i,staticStyle:{"margin-bottom":"20px"},attrs:{"swiper-id":('pro1' + i),"project":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }